module.exports = __webpack_public_path__ + "img/cat-02-in.e0486562.svg";